import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { LookupObjectModel } from 'src/app/models/lookup-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LookupObjectService {

  constructor(private httpClient: HttpClient) {
  }
  
  getLookupObjectsByGroupName(groupName: string): Observable<LookupObjectModel[]> {
    return this.httpClient.get<LookupObjectModel[]>(environment.apiBaseUrl + `LookupObject/${groupName}`);
  }
  
}
